// extracted by mini-css-extract-plugin
module.exports = {"heading":"t4d57"};